module.exports = __webpack_public_path__ + "assets/img/thumb-ARUMALABS-2-Video.b7def0f1.jpg";